import { USER_TYPES_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(USER_TYPES_ENDPOINT);
export default instance;
